import { createSlice } from '@reduxjs/toolkit'
import { LOCALES } from '../i18n/locales';
import AccountTag from '../modules/notes/model/AccountTag';

type AppStoreState = {
    locale: string,
    accountTags: AccountTag[]
}

var initState: AppStoreState = {
    locale: LOCALES.ENGLISH,
    accountTags: []
};

export const AppStore = createSlice({
    name: 'project',
    initialState: initState,
    reducers: {
        setLocale: (state, payloadAction) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.locale = payloadAction.payload;
        },
        storeAccountTags: (state, payloadAction) => {
            state.accountTags = payloadAction.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setLocale, storeAccountTags } = AppStore.actions

export default AppStore.reducer